var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card__header"},[_c('button',{staticClass:"btn-close",on:{"click":function($event){return _vm.$emit('closeApp')}}},[_c('img',{attrs:{"src":require("@/assets/img/icons/close.svg"),"alt":"button"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }